import React from 'react';
import './form.css';

const Form = ({ setInputText, todos, setTodos, inputText }) => {
  const inputTextHandler = (e) => {
    setInputText(e.target.value);
  };
  const submitTodoHandler = (e) => {
    e.preventDefault();
    if (inputText.trim() !== '') {
      setTodos([
        ...todos,
        {
          text: inputText,
          completed: false,
          important: false,
          id: Math.random() * 1000,
        },
      ]);
      setInputText('');
    }
  };
  return (
    <form className='toDo__form'>
      <p className='toDo__label'>New Task</p>
      <textarea
        value={inputText}
        onChange={inputTextHandler}
        name='new-task'
        className='toDo__input'
      ></textarea>
      <div className='toDo__button-wraper'>
        <button onClick={submitTodoHandler} className='toDo__button'>
          ADD
        </button>
      </div>
    </form>
  );
};

export default Form;
